// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"6d359658","19":"7daa429e","80":"aa68f0e6","159":"688280f6","416":"b8081121","538":"1f205cf6","545":"749d4038","566":"3e7fd90d","577":"d1b413e4","676":"2a65f722","963":"06e3e4a5"}[chunkId] + ".chunk.js";
};